import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class TrainingProtocolApiService extends ApiService {
  static async getPaginated(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('training-protocols', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  static async getAll(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('training-protocols', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async getDetails(id: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`training-protocols/${id}`)
      .then((response: AxiosResponse) => response.data)
  }

  static async create(data: object): Promise<IServiceResponse<object>> {
    return this.axios.post('training-protocols', data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async update(trainingProtocolId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.put(`training-protocols/${trainingProtocolId}`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async delete(trainingProtocolId: string): Promise<AxiosResponse> {
    return this.axios.delete(`training-protocols/${trainingProtocolId}`)
  }
}
